import SendAnAlert from "./SendAnAlert";

export default SendAnAlert;
